import React from "react";
import Select from "react-select";

const RATING_OPTIONS = [1, 2, 3, 4].map((v) => ({ label: `L${v}`, value: v }));
const TICK_OPTIONS = [
    { label: "1 Tick", value: 1 },
    { label: "2 Ticks", value: 2 },
    { label: "3 Ticks", value: 3 },
    { label: "4 Ticks", value: 4 },
];

const FieldInput = ({ field, value, invalid, isLocked }) => {
    if (field.isTextBox) {
        return (
            <>
                <input
                    type="text"
                    className="common-input"
                    placeholder="Textbox"
                    style={invalid ? { borderColor: "red" } : {}}
                    value={value || ""}
                    required={field.isRequired}
                    disabled={isLocked}
                />
                {invalid && (
                    <span style={{ color: "red", fontSize: "12px", display: "block" }}>
                        This field is required
                    </span>
                )}
            </>
        );
    }

    if (field.isRating) {
        return (
            <>
                <Select
                    options={RATING_OPTIONS}
                    value={RATING_OPTIONS.find((o) => o.value === Number(value)) || null}
                    className="evalutionselect"
                    isDisabled={isLocked}
                />
                {invalid && (
                    <span style={{ color: "red", fontSize: "12px", display: "block" }}>
                        Please select a rating
                    </span>
                )}
            </>
        );
    }

    if (field.isTickRating) {
        return (
            <>
                <Select
                    options={TICK_OPTIONS}
                    value={TICK_OPTIONS.find((o) => o.value === Number(value)) || null}
                    className="evalutionselect"
                    isDisabled={isLocked}
                />
                {invalid && (
                    <span style={{ color: "red", fontSize: "12px", display: "block" }}>
                        Please select an option
                    </span>
                )}
            </>
        );
    }

    return null;
};

export default FieldInput;